import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { handleOnConnect, handleHMR } from '../virtusa-redux'
import { useSelector } from 'react-redux'

import { createUiTheme, lightTheme, themeChoices } from '.'

const defaultTheme = lightTheme

const reducerKey = 'theme'

// Define the redux initial state at the reducer key
const initialState = {
  theme: defaultTheme,
  themeObject: {}
}

let { setState, getState } = handleHMR(module, initialState)

export const initThemeReducer = (store) => {
  ({ setState, getState } = handleOnConnect(store, { reducerKey, initialState }))
}

export const clearTheme = () => {
  setState(initialState)
} 

export const themeSelector = () =>
  getState().theme

export const themeObjectSelector = () =>
  getState().themeObject

// This can be used outside of this component to change the theme program wide.
export const setTheme = theme => {
  if (typeof theme === 'number') {
    theme = themeChoices[theme].value
  }
  setState({ theme })
}

/**
 * ThemeWrapper sets up the theming
 *
 * @param {object} props component props
 * @param {Node} props.children App child nodes
 * @returns {React.ReactElement} - React component
 */
export const ThemeWrapper = props => {
  const firstTime = useRef(true)
  // Can determine if the theme changed.
  const theme = useSelector(themeSelector)
  const [muiTheme, setMuiTheme] = useState(createUiTheme(defaultTheme))

  // Used to pick up any changes to the theme to cause a re-render of the app with the new theme.
  useEffect(() => {
    const themeObject = createUiTheme(theme)
    if (firstTime.current) {
      firstTime.current = false
      setState({ themeObject })
      return
    }
    setMuiTheme(themeObject)
    setState({ themeObject })
  }, [theme])

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}

ThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}
